"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.funcParams = void 0;
exports.funcParams = `$root,$parent,$parent2,$parent3,$external,$methods,$obj,$value,$event`;
exports.default = exports.funcParams;
//# sourceMappingURL=funcParams.js.map